export function appConfig($urlRouterProvider, $httpProvider, $sceDelegateProvider/* $ocLazyLoadProvider */) {
    'ngInject'
    $httpProvider.interceptors.push('httpInterceptor')
    // 设置ie不缓存
    if (!$httpProvider.defaults.headers.common) {
        $httpProvider.defaults.headers.common = {}
    }
    $httpProvider.defaults.headers.common['If-Modified-Since'] = '0'
    $httpProvider.defaults.headers.common['Cache-Control'] = 'no-cache'
    $httpProvider.defaults.headers.common.Pragma = 'no-cache'

    // 默认路由设置
    $urlRouterProvider.otherwise('/login')
    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        'self',
        // Allow loading from our assets domain.  Notice the difference between * and **.
        `${host.etcloudBiReport}**`])
}



// WEBPACK FOOTER //
// ./src/app/config.js